import React from 'react';
import PropTypes from 'prop-types';

import Spacing from '@marvelapp/marvel-ui/spacing';
import Heading from '@marvelapp/marvel-ui/heading';
import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import MaxWidth from '@marvelapp/marvel-ui/max-width';

import ExperienceCard from 'marketing-website/components/modules/CompetitorAlternatives/ExperienceCard.js';

import styles from './style/experience.module.css';

export default function Experience({ headingText, config }) {
  return (
    <div className={styles.main}>
      <div className={styles.wrap}>
        <Spacing size="xl" type="padding" position="bottom">
          <MaxWidth value={800}>
            <Heading tag="h2" weight="bold" size="xxxxl" color="black">
              {headingText}
            </Heading>
          </MaxWidth>
        </Spacing>

        <Grid columns={3} alignItems="stretch" size="l">
          {config.map(item => (
            <GridItem columnSpan={3} columnSpanL={1}>
              <ExperienceCard
                title={item.title}
                subtitle={item.subtitle}
                image={item.image}
              />
            </GridItem>
          ))}
        </Grid>
      </div>
    </div>
  );
}

Experience.propTypes = {
  headingText: PropTypes.string.isRequired,
  config: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/modules/CompetitorAlternatives/Experience.js